module.exports = "<settings-screen>\n  <div class=\"row m-t-5\">\n    <div class=\"col-md-6\">\n      <dynamic-form target=\"destination\" type=\"destinations\">\n        <button class=\"btn btn-danger\" ng-if=\"destination.id\" ng-click=\"delete()\">Delete</button>\n      </dynamic-form>\n    </div>\n  </div>\n</settings-screen>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/pages/destinations/show.html
// module id = 774
// module chunks = 1